import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { APP_CONFIG, IAppConfig } from './../../../app.config';
import { Profile } from '../../model/profile';
import { EmailProviderTestRequest, ProfileSettings } from '../../model/profile-settings';
import { ProfileService } from './profile.service';

@Injectable()
export class ProfileManagementService extends ProfileService {
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig) {
    super(client, config);
    this._photo = config.apiEndpointV2 + '/systemowner/photo';
    this._profilePut = config.apiEndpointV2 + '/systemowner/profile';
    this._profileSettings = config.apiEndpointV2 + '/systemowner/profile-settings';
    this._profileSettingsTestEmail = config.apiEndpointV2 + '/systemowner/profile-settings/test-email';
    this._protectedIdentityApiKey = config.apiEndpointV2 + '/systemowner/profile-settings/protected-identity-api-key';
  }

  private _photo: string;
  private _profilePut: string;
  private _profileSettings: string;
  private _profileSettingsTestEmail: string;
  private _protectedIdentityApiKey: string;

  change(profile: Profile): Observable<any> {
    return this._client.put(this._profilePut, JSON.stringify(profile), { headers: { 'Content-Type': 'application/json' } });
  }

  getProfileSettings(): Observable<ProfileSettings> {
    return this._client.get<ProfileSettings>(this._profileSettings);
  }

  setPhoto(photo: File): Observable<any> {
    const formData = new FormData();
    formData.append('logo', photo, photo.name);
    return this._client.post(this._photo, formData);
  }

  setProfileSettings(form: any): Observable<any> {
    return this._client.put(this._profileSettings, JSON.stringify(form));
  }

  testEmailProvider(request: EmailProviderTestRequest): Observable<void> {
    return this._client.post<void>(this._profileSettingsTestEmail, request);
  }

  generateProtectedIdentityApiKey(): Observable<void> {
    return this._client.post<void>(this._protectedIdentityApiKey, null);
  }
}
